/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Skeleton } from "@/components/ui/skeleton";
import { AlarmClock, Dot, EllipsisVertical, User, X } from "lucide-react";
import AddNewBookingForm from "./AddNewBookingForm";
import { getSingleTable, updateBookingTable, updateLiveBookingTable } from "@/api/table-floor/tableFloor";
import { toast } from "react-hot-toast";
import SwapTableModal from "../liveTable/SwapTableModal";
import { getDuration, isCurrentBooking } from "@/lib/bookingUtils";
import { useDispatch, useSelector } from "react-redux";
import { openAddNewBookingTableModal, closeAddNewBookingTableModal, fetchAndReplaceBooking } from "@/redux/slice/table-slice/table-slice";
import { resetSelectedBookingTable } from "@/redux/slice/table-slice/booking-table-slice";
import hasPermission from "@/hooks/hasPermission";

const BookingDetails = ({ itemsDialog, tableType }) => {
  // console.log(itemsDialog);
  const { bookingDetails, loading } = useSelector((state) => state.table.bookingTable);
  const dispatch = useDispatch();
  // const { isAddNewBookingTableModalOpen  } = useSelector((state) => state.table.table);
  // const { }
  const [formType, setFormType] = useState("create");
  // const [booking, setBooking] = useState([]);
  // const [loading, setloading] = useState(true);
  // const [isAddNewBookingTableModalOpen, setIsAddNewBookingTableModalOpen] = useState(false);
  // const closeAddNewBookingTableModal = () => {
  // 	setIsAddNewBookingTableModalOpen(false);
  // };
  const statuses = [
    { label: "Confirmed", value: "confirmed" },
    { label: "Pending", value: "pending" },
    { label: "Cancelled by Customer (CC)", value: "canceled_by_customer" },
    { label: "Cancelled by Admin (CA)", value: "canceled_by_admin" },
    // { label: "Waiting", value: "waiting" },
    // { label: "Cancelled by Customer (CC)", value: "cancelled_customer" },
    // { label: "Cancelled by Admin (CA)", value: "cancelled_admin" },
  ];

  const [bookingStatuses, setBookingStatuses] = useState({});
  const handleChangeStatus = async (bookingId, value) => {
    const previousStatus =
      bookingStatuses[bookingId] ||
      bookingDetails.bookings.find(b => b.id === bookingId)?.status;

    setBookingStatuses((prev) => ({
      ...prev,
      [bookingId]: value,
    }));
    try {
      let res;
      res = await updateBookingTable(bookingId, { "status": value });
      if (res.status === "success") {
        toast.success("Booking status updated successfully!");
      } else {
        toast.error(res.message || "Something went wrong!");
      }
    } catch {
      toast.error(err?.message || "Failed to process Floor Card");
      setBookingStatuses((prev) => ({
        ...prev,
        [bookingId]: previousStatus,
      }));
    }
  };

  const groupedBookings = bookingDetails.bookings.reduce((acc, booking) => {
    const date = booking?.reservation_date?.split("T")[0];
    if (!acc[date]) acc[date] = [];
    acc[date].push(booking);
    return acc;
  }, {});


  console.log("Grouped Bookings:", groupedBookings);

  // Format date like: 24 July 2025 - Monday
  const formatDateWithDay = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      weekday: "long",
    });
  };

  // Format time like: 03:45 AM
  const formatTime = (time) => {
    if (!time) return "-";
    const [h, m] = time.split(":");
    const date = new Date();
    date.setHours(h, m);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const [isSwapTableModalOpen, setIsSwapTableModalOpen] = useState(false);
  const [swapBookingId, setSwapBookingId] = useState("")
  const closeSwapTableModal = () => {
    setIsSwapTableModalOpen(false);
  };

  const [bookingItemForEdit, setBookingItemForEdit] = useState(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [isMiniModalOpen, setIsMiniModalOpen] = useState(false);
  const [tableForBookingForm, setTableForBookingForm] = useState(null)
  const handleClose = () => {
    setIsMiniModalOpen(!isMiniModalOpen);
  };
  const handleMenuOpen = (e, booking) => {
    const rect = e.currentTarget.getBoundingClientRect();

    setMenuPosition({
      top: rect.bottom + 4,
      left: rect.left - 100,
    });
    setIsMiniModalOpen(true);
    setBookingItemForEdit(booking);
  };

  // const [hasFetched, setHasFetched] = useState(false);

  // useEffect(() => {
  //   if (
  //     // !hasFetched &&
  //     // isAddNewBookingTableModalOpen &&
  //     // (formType === "update" || formType === "view") &&
  //     bookingItemForEdit &&
  //     !bookingItemForEdit?.customer?.number
  //   ) {
  //     dispatch(fetchAndReplaceBooking(bookingItemForEdit?.id));
  //     // setHasFetched(true);
  //   }
  // }, [bookingItemForEdit]);\



  function onClose() {
    dispatch(resetSelectedBookingTable());
    // setIsAddNewBookingTableModalOpen(false);
    setBookingStatuses({});
  }


  console.log("Booking Details Rendered with bookingDetails:", bookingDetails);

  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
        <Card className="bg-cblack4 text-cwhite w-[600px] max-h-[90vh] overflow-y-scroll">
          <CardHeader className="flex flex-row justify-between items-center">
            <CardTitle className="text-cwhite text-sm font-medium">
              {itemsDialog?.name} {tableType === "live_table" ? "Live Table Details" : "Table Booking Details"}
            </CardTitle>

            <X onClick={onClose} className="cursor-pointer" size={16} />
          </CardHeader>
          <Separator />
          <CardContent>
            <div className="mt-8">
              {loading ? (
                // Skeleton Loading
                <div className="space-y-4">
                  <p className="text-xs font-normal text-center mb-4">
                    <Skeleton className="h-4 w-48 mx-auto" />
                  </p>
                  {[...Array(3)].map((_, i) => (
                    <div key={i} className="bg-gray-800 p-2 rounded-sm shadow-lg w-full border border-transparent">
                      <div className="flex justify-between">
                        <div className="flex w-1/2">
                          <div className="text-center pr-2 border-r-2 border-white flex flex-col justify-between">
                            <Skeleton className="h-4 w-16 mb-2" />
                            <Skeleton className="h-3 w-10 mb-2" />
                            <Skeleton className="h-4 w-16" />
                          </div>
                          <div className="pl-2 w-full flex flex-col justify-between">
                            <Skeleton className="h-4 w-32 mb-2" />
                            <Skeleton className="h-4 w-40" />
                          </div>
                        </div>
                        <div className="flex flex-col gap-2 w-1/3 justify-between">
                          <Skeleton className="h-3 w-20" />
                          <Skeleton className="h-8 w-full rounded-full" />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : bookingDetails?.bookings?.length > 0 ? (
                Object.entries(groupedBookings).map(([date, bookings]) => (
                  <div key={date}>
                    <p className="text-xs font-normal text-center mb-4">
                      {formatDateWithDay(date)}
                    </p>
                    {bookings.map((item, i) => {
                      const currentStatus = bookingStatuses[item.id] || item.status;

                      return (
                        <div
                          key={i}
                          className={`bg-gray-800 p-2 rounded-sm shadow-lg w-full mb-4 border border-transparent`}
                        >
                          <div className="flex justify-between">
                            <div className="flex">
                              <div className="text-center pr-2 border-r-2 border-white">
                                <p className="text-[14px] font-normal">{formatTime(item.start_time)}</p>
                                <p className="text-[12px] text-gray-500 font-normal">to</p>
                                <p className="text-[14px] font-normal">
                                  {formatTime(item.end_time) || "-"}
                                </p>
                              </div>

                              <div className="text-[14px] font-normal flex flex-col justify-between pl-2">
                                <p>{item?.customer?.full_name || "Md Rasel Mahmud"}</p>
                                <p className="flex items-center">
                                  <User size={16} className="mr-1" />
                                  {item?.guest || 0} <Dot /> £ {item?.advance || "0.00"}
                                </p>
                              </div>
                            </div>
                            <div className="flex gap-4">
                              <div className="flex flex-col justify-between">
                                <p className="text-[11px] font-medium flex items-center justify-between">
                                  <span>ID: {item?.unique_id || item?.id}</span>
                                  <span
                                    className="cursor-pointer"
                                    onClick={(e) => { handleMenuOpen(e, item); setTableForBookingForm(itemsDialog) }}
                                  >
                                    <EllipsisVertical />
                                  </span>
                                </p>
                                <select
                                  value={currentStatus}
                                  onChange={(e) => { handleChangeStatus(item.id, e.target.value) }}
                                  className={`${currentStatus === "confirmed"
                                      ? "bg-green-700"
                                      : currentStatus === "pending"
                                        ? "bg-orange-500"
                                        : currentStatus === "canceled_by_customer"
                                          ? "bg-red-600"
                                          : "bg-red-800"
                                    } text-white py-1 pl-2 rounded-full border-none cursor-pointer text-[12px] font-normal`}
                                >
                                  {
                                    statuses.map((statusOption, i) => (
                                      <option key={i} value={statusOption.value}>
                                        {statusOption.label}
                                      </option>
                                    ))
                                  }
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                ))
              ) : (
                <div className="bg-[#2F2F2F] h-60 w-full flex items-center justify-center">
                  <p className="text-[14px] font-normal">
                    No reservations scheduled today for this table
                  </p>
                </div>
              )}
              {
                tableType === "book_table" && hasPermission("table.book_table.create_booking") && <button onClick={() => { dispatch(openAddNewBookingTableModal()); setTableForBookingForm(itemsDialog); setBookingItemForEdit(itemsDialog) }} className="bg-[#36cc2a] py-3 w-full rounded text-xs font-medium mt-4">Book Table</button>
              }
            </div>
          </CardContent>
        </Card>
      </div>

      {/* OVERLAY (for outside click) */}
      {isMiniModalOpen && <div className="fixed inset-0 z-[999]" onClick={handleClose}></div>}
      {/* MINI MODAL */}
      {isMiniModalOpen && (
        <div
          className="fixed z-[1000] bg-[#3a3a3a] border border-gray-600 rounded shadow-lg w-36"
          style={{
            top: menuPosition.top,
            left: menuPosition.left,
          }}
        >
          <button className="w-full text-left px-4 py-2 hover:bg-gray-700" onClick={() => { setFormType("update"); setIsMiniModalOpen(false); dispatch(openAddNewBookingTableModal()) }}>
            Edit
          </button>
          <button className="w-full text-left px-4 py-2 hover:bg-gray-700" onClick={() => { setFormType("view"); setIsMiniModalOpen(false); dispatch(openAddNewBookingTableModal()) }}>
            View Details
          </button>
          {/* <button className="w-full text-left px-4 py-2 hover:bg-gray-700" onClick={() => { setDeleteDialog(true); }}>
            Delete
          </button> */}
        </div>
      )}

      <AddNewBookingForm
        // isOpen={isAddNewBookingTableModalOpen}
        // onClose={closeAddNewBookingTableModal}
        formType={formType}
        setFormType={setFormType}
        bookingItemForEditId={bookingItemForEdit?.id}
        selectedTable={tableForBookingForm}
      />
      <SwapTableModal
        isOpen={isSwapTableModalOpen}
        onClose={closeSwapTableModal}
        swapBookingId={swapBookingId}
        itemsDialog={itemsDialog}
      />
    </>
  );
};

export default BookingDetails;